import { IMedicationReconciliationRepository } from "../../adapters/driven/repositories/medicationReconciliationRepository";

export const MedicationReconciliationServiceFactory = ({
  medicationReconciliationRepository,
}: {
  medicationReconciliationRepository: IMedicationReconciliationRepository;
}): IMedicationReconciliationService => {
  const uploadDischargePdf: IUploadDischargePdfService = async (payload) => {
    try {
      const response =
        await medicationReconciliationRepository.uploadDischargePdfAPI(payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getDischargePdfUploads: IGetDischargePdfUploadsService = async (
    payload
  ) => {
    try {
      const response =
        await medicationReconciliationRepository.getDischargePdfUploadsAPI(
          payload
        );
      // FastAPI returns the list directly, but our type expects { data: [...] }
      // Handle both cases: direct list or wrapped in data
      const pdfList = Array.isArray(response) ? response : response.data || [];
      return {
        success: true,
        data: pdfList,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getMedRecAdmissions: IGetMedRecAdmissionsService = async (payload) => {
    try {
      const response =
        await medicationReconciliationRepository.getMedRecAdmissionsAPI(
          payload
        );
      const data = Array.isArray(response) ? response : [];
      return {
        success: true,
        data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateFindingStatus: IUpdateFindingStatusService = async (payload) => {
    try {
      const response =
        await medicationReconciliationRepository.updateFindingStatusAPI(
          payload
        );
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    uploadDischargePdf,
    getDischargePdfUploads,
    getMedRecAdmissions,
    updateFindingStatus,
  };
};
